/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
import React, { useEffect } from "react";
import api from "../../services/api";

const Home: React.FC = () => {
    // const message = `Olá, vim pelo seu site e gostaria de saber mais sobre as ofertas de iPhone.`;

    useEffect(() => {
        api.get("/vendedores/loja/proximo/9/home").then(
            (response: {
                data: { vendedor: { celular: any }; mensagem: any };
            }) =>
                (window.location.href = `https://api.whatsapp.com/send?phone=${response.data.vendedor.celular}&text=${response.data.mensagem}`),
        );
    }, []);

    return <p />;
};

export default Home;
